<admin-layout>
    <div class="container-admin">
      <router-outlet></router-outlet>
    </div>
</admin-layout>
